module.exports = __webpack_public_path__ + "img/subscription-trigger.c10ea201.png";